import { ConfirmDialogDesignTokens } from '@primeuix/themes/aura/confirmdialog';

export const confirmDialogTokens: ConfirmDialogDesignTokens = {
  icon: {
    size: '2rem',
    color: '{overlay.modal.color}',
  },
  content: {
    gap: '1rem',
  },
  css: ({ dt }) => `
    .p-confirmdialog-accept-button,
    .p-confirmdialog-reject-button {
      width: 100%;
      font-size: ${dt('button.sm.font.size')};
      padding-block: ${dt('button.sm.padding.y')} !important;
      padding-inline: ${dt('button.sm.padding.x')} !important;
    }

    .p-dialog-footer p-button {
      flex: 1;
    }
  `,
};
